<template>
  <div class="emailreport">
    <h1>Rapporter</h1>
    
    <div class="report-inputs-wrapper">
      <div class="report-input-container">
        <label>Ankomst från<br>
          <input type="date" v-model="from">
        </label>
      </div>

      <div class="report-input-container">
        <label>Ankomst till<br>
          <input type="date" v-model="to">
        </label>
      </div>

      <div class="report-input-container">
        <label>Kod<br>
          <input type="text" v-model="code">
        </label>
      </div>

      <div style="width: 100%;"></div>

      <div class="report-input-container">
        <label>Rader</label>
        <div class="checkboxes-container">
          <label style="font-weight:normal;" v-for="option in lineTypeOptions" :key="'line_type' + option.value">
            <input type="checkbox" v-model="line_types[option.value]" v-if="option.text !== 'disabled'">
            <span v-if="option.text !== 'disabled'">{{option.text}}</span>
          </label>
        </div>
      </div>

      <div style="width: 100%;"></div>

      <div class="report-input-container">
        <label>Källa</label>
        <div class="checkboxes-container">
          <label style="font-weight:normal;" v-for="option in orderSourceOptions" :key="'order_source' + option.value">
            <input type="checkbox" v-model="order_sources[option.value]"> {{option.text}}
          </label>
        </div>
      </div>

      <div style="width: 100%;"></div>

      <div class="report-input-container">
        <label>Minst antal dagar<br>
          <input type="text" v-model="days_min">
        </label>
      </div>

      <div class="report-input-container">
        <label>Max antal dagar<br>
          <input type="text" v-model="days_max"><br>
        </label>
      </div>

      <div style="width: 100%;"></div>
      <div class="help">Detta filter funkar inte på alla typer av rader, t.ex. boendetillval</div>
      <div style="width: 100%;"></div>
    </div>

    <div class="report">
      <a class="button" :href="getReportEmailLink()" @click="showInfo">Huvud: Epost/tfn</a>
      <p class="info">Rapporten innehåller e-postadresser och telefonnummer.</p>
    </div>

    <div class="report">
      <a class="button" :href="getReportEmailExtendedLink()" @click="showInfo">Rader: E-post/tfn/mer</a>
      <p class="info">Rapporten innehåller e-postadresser, telefonnummer, produktkod, pool-ID, antal dagar samt ankomstdatum för <b>varje bokningsrad</b>.</p>
    </div>

    <div class="report">
      <a class="button" :href="getReportCodesWithExtraInfoLink()" @click="showInfo">Huvud: Med kod</a>
      <p class="info">Rapporten innehåller kundinfo, boende, kod, bokning samt fritextfält för kodbokningar.</p>
    </div>
  </div>
</template>

<script>
import API from '@/classes/API';
import moment from 'moment';

export default {
  components: {
  },
  data() {
    return {
      from: moment().format('YYYY-MM-DD'),
      to: moment().add(1, 'months').format('YYYY-MM-DD'),
      code: '',
      days_min: '',
      days_max: '',
      order_sources: {
        web: true,
        mobile: true,
      },
      line_types: {
        equipment: true,
        accomodation: true,
        accomodation_addon: true,
        equipment_addon: true,
        skipass: true,
        accomodation_skipass: true,
        skischool: true,
        skipass_keycard: true,
        // activity: true,
        product: true,
      },
    };
  },
  computed: {
    currentDomain() {
      return `${this.SITE_CONFIG.site}.se`;
    },
    orderSourceOptions() {
      return [
        { value: 'web', text: 'Via webb' },
        { value: 'mobile', text: `Via hyra.${this.currentDomain}` },
      ];
    },
    lineTypeOptions() {
      return [
        { value: 'equipment', text: 'Utrustning' },
        { value: 'equipment_addon', text: 'Utrustningstillval' },
        { value: '___equipment', text: 'disabled' },
        { value: 'skipass', text: 'Liftkort' },
        { value: 'accomodation_skipass', text: 'Boendeliftkort' },
        { value: 'skipass_keycard', text: 'Keycard' },
        { value: 'product', text: 'Produkt' },
        { value: '___skipass', text: 'disabled' },
        { value: 'accomodation', text: 'Boende' },
        { value: 'accomodation_addon', text: 'Boendetillval' },
        { value: '___accomodation', text: 'disabled' },
        { value: 'skischool', text: 'Skidskola' },
        // { value: 'activity', text: 'Aktivitet' },
      ];
    },
  },
  methods: {
    showInfo() {
      this.$toast.info('Exporten laddas snart ned. Stäng inte fönstret', 'Förbereder', {
        position: 'topRight',
      });
    },
    getReportEmailLink() {
      const reportUrl = API.getUrl(`${this.getBaseLink()}&report=emails`);
      return reportUrl;
    },
    getReportEmailExtendedLink() {
      const reportUrl = API.getUrl(`${this.getBaseLink()}&view=line&report=emails-extended`);
      return reportUrl;
    },
    getReportCodesWithExtraInfoLink() {
      const reportUrl = API.getUrl(`${this.getBaseLink()}&report=codes_with_extra_info`);
      return reportUrl;
    },
    getBaseLink() {
      const auth = API.authSimpleParameter;
      const sources = Object.keys(this.order_sources).filter(key => this.order_sources[key]).join(',');
      const types = Object.keys(this.line_types).filter(key => this.line_types[key]).join(',');
      const daysMin = this.days_min || '';
      const daysMax = this.days_max || '';
      return `/stats/orders?start=${this.from}&end=${this.to}&payment_code=${this.code}&property=arrival&page=1&pp=99999&payed=yes&auth-simple=${auth}&order_sources=${sources}&types=${types}&days_min=${daysMin}&days_max=${daysMax}`;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.help
  font-size: 0.8em
  color: #666
  font-weight 300

.emailreport
  admin-container()

  .report-inputs-wrapper
    display flex
    margin-bottom 1em
    flex-wrap: wrap

    .report-input-container
      margin-right 1em
      margin-top 1em

      input[type="date"],
      input[type="text"]
        padding 0.5em

      .checkboxes-container
        display: flex
        padding-top: 0.5em
        label 
          margin-right 1em

  .report
    margin-bottom 1em
    display: flex
    max-width: 800px
    align-items: flex-start
    .button
      width 300px
      margin-right 1em
    .info
      width: calc(100% - 350px)
</style>



// WEBPACK FOOTER //
// EmailReport.vue?e9a19c9c